import { Badge } from "@shared/ui/badge";
import { User } from "lucide-react";
import React from "react";

interface ConsumerListItemProps {
  consumer: any;
  onClick: (consumer: any) => void;
}

export const ConsumerListItem: React.FC<ConsumerListItemProps> = ({
  consumer,
  onClick,
}) => {
  const statusBadge = (status: string) => {
    console.log("status", status);
    if (status === "ACTIVE")
      return (
        <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-medium">
          Active
        </span>
      );
    if (status === "INACTIVE")
      return (
        <span className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs font-medium">
          Inactive
        </span>
      );
    if (status === "PENDING")
      return (
        <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-xs font-medium">
          Pending
        </span>
      );
    if (status === "DISCONNECTED")
      return (
        <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-medium">
          Disconnected
        </span>
      );
    return (
      <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs font-medium">
        {status}
      </span>
    );
  };
  console.log(consumer);
  const getStatusVariant = (status: any["status"]) => {
    return status === "Active" ? "default" : "destructive";
  };

  const getStatusClassName = (status: any["status"]) => {
    return status === "Active"
      ? "bg-green-100 text-green-800 hover:bg-green-100"
      : "bg-red-100 text-red-800 hover:bg-red-100";
  };

  return (
    <div
      onClick={() => onClick(consumer)}
      className="flex items-center gap-3 p-4 hover:bg-gray-50 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0"
    >
      {/* User Icon */}
      <div className="flex-shrink-0">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
          <User className="w-5 h-5 text-blue-600" />
        </div>
      </div>

      {/* Consumer Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="font-medium text-gray-900">
            {consumer.firstName + " " + consumer.lastName}
          </p>

          {statusBadge(consumer.statusDisplay)}
        </div>
        <p className="text-sm text-gray-500 mt-1">
          Account No: {consumer.consumerNo} • {consumer.contactNumber} •{" "}
          {consumer.email}
        </p>
      </div>
    </div>
  );
};
